import { useCallback, useEffect, useState } from 'react';
import { eventEmitter } from './eventEmmitter';

const defaultHomePagePreference = 'log';
export const useHomePagePreference = () => {
  const [homePagePreference, _setHomePagePreference] = useState<string>('');

  useEffect(() => {
    _setHomePagePreference(localStorage.getItem('homePageFormat') || defaultHomePagePreference);
  }, []);

  useEffect(() => {
    const off = eventEmitter.on('HOME_PAGE_PREFERENCE_CHANGED', (newPreference) => {
      if (newPreference === 'log' || newPreference === 'calendar') {
        _setHomePagePreference(newPreference);
      } else {
        console.warn('Invalid home page preference:', newPreference);
      }
    });
    return () => {
      off();
    };
  }, []);

  const setHomePagePreference = useCallback((newPreference: string) => {
    localStorage.setItem('homePageFormat', newPreference);
    eventEmitter.emit('HOME_PAGE_PREFERENCE_CHANGED', newPreference);
  }, []);

  return [homePagePreference, setHomePagePreference] as const;
};
